import { Button, FormControlLabel, IconButton, LinearProgress, Radio, RadioGroup, Typography } from '@material-ui/core';
import '../styles/Globales.scss';
import '../styles/SolicitarPortabilidad.scss';

import React, { Component } from 'react';
import { KeyboardBackspaceOutlined } from '@material-ui/icons';
import SwitchComponent from './utils/SwitchComponent';
import TextRipleyComponent from './utils/TextRipleyComponent';
import * as ValidationUtils from '../utils/ValidationUtils';
import ViewConstants from '../utils/ViewConstants';
import appStore from '../stores/AppStore';

const NO_DEFINIDO = 'N/A';
const SI = 'SI';
const NO = 'NO';
export default class ContratarProductosComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      creditoSeleccionado: false,
      tarjetaSeleccionada: false,
      cuentaVistaSeleccionada: false,
      isValid: true,
      montoCredito: '',
      errorMonto: true,
      errorTxtMonto: '',
      plazo: '',
      errorPlazo: true,
      errorTxtPlazo: '',
      objetivoDeuda: NO_DEFINIDO,
    };
  }

  componentDidMount = () => {
    const currentValue = this.getCurrentValue();
    this.setState(
      {
        creditoSeleccionado: currentValue.creditoSeleccionado,
        tarjetaSeleccionada: currentValue.tarjetaSeleccionada,
        cuentaVistaSeleccionada: currentValue.cuentaVistaSeleccionada,
        montoCredito: currentValue.montoCredito,
        errorMonto: true,
        errorTxtMonto: '',
        plazo: currentValue.plazo,
        errorPlazo: true,
        errorTxtPlazo: '',
        objetivoDeuda: currentValue.objetivoDeuda,
      },
      this.validarFormulario
    );
  };

  getCurrentValue = () => {
    let result = {
      creditoSeleccionado: false,
      tarjetaSeleccionada: false,
      cuentaVistaSeleccionada: false,
      montoCredito: '',
      plazo: '',
      objetivoDeuda: NO_DEFINIDO,
    };
    if (appStore.solicitarNuevaPortalidadStore.productosContratar) {
      result = appStore.solicitarNuevaPortalidadStore.productosContratar;
    }
    return result;
  };

  onCreditoChange = (value) => {
    this.setState(
      (prevState) => {
        const { errorMonto, errorPlazo } = prevState;
        return {
          creditoSeleccionado: value,
          montoCredito: value ? prevState.montoCredito : '',
          plazo: value ? prevState.plazo : '',
          objetivoDeuda: value ? prevState.objetivoDeuda : NO_DEFINIDO,
          errorMonto,
          errorPlazo,
        };
      },
      this.validarFormulario
    );
  };


  onTarjetachange = (value) => {
    this.setState({ tarjetaSeleccionada: value }, this.validarFormulario);
  };

  onCuentaVistaChange = (value) => {
    this.setState({ cuentaVistaSeleccionada: value }, this.validarFormulario);
  };

  onChangeObjetivoDeuda = (evt) => {
    const value = evt.target.value;
    this.setState({ objetivoDeuda: value }, this.validarFormulario);
  };

  onChangeMonto = (evt) => {
    const num = evt.target.value;
    if (num) {
      const value = ValidationUtils.unformat(num);
      if (ValidationUtils.isNumberOrEmpty(value)) {
        this.setState(
          {
            montoCredito: value,
            errorMonto: false,
            errorTxtMonto: '',
          },
          this.validarFormulario
        );
      }
    } else {
      this.setState(
        {
          montoCredito: num,
          errorMonto: true,
          errorTxtMonto: 'Debe ingresar un monto',
        },
        this.validarFormulario
      );
    }
  };

  onChangePlazo = (evt) => {
    const num = evt.target.value;
    const reg = /^[0-9]+$/;
    if (num.length <= 3) {
      if (num.match(reg)) {
        this.setState(
          {
            plazo: num,
            errorPlazo: false,
            errorTxtPlazo: '',
          },
          this.validarFormulario
        );
      } else {
        this.setState(
          {
            plazo: num,
            errorPlazo: true,
            errorTxtPlazo: 'Debe ingresar un valor para plazo',
          },
          this.validarFormulario
        );
      }
    }
  };

  validarFormulario = () => {
    if (this.state.creditoSeleccionado) {
      if (this.state.objetivoDeuda === NO_DEFINIDO) {
        this.setState({ isValid: false });
      } else if (this.state.objetivoDeuda === NO) {
        this.setState({ isValid: true });
      } else if (!this.state.errorMonto && !this.state.errorPlazo) {
        this.setState({ isValid: true });
      } else {
        this.setState({ isValid: false });
      }
    } else {
      this.setState(
        (prevState) => ({
          isValid: prevState.tarjetaSeleccionada || prevState.cuentaVistaSeleccionada,
        })
      );
    }
  };

  onContinuar = () => {
    if (appStore.solicitarNuevaPortalidadStore.portaTodosSusProductos()) {
      appStore.generateDataLayer({ eventAction: 'step_5', eventLabel: 'todos_productos_contratar_continuar' });
    } else {
      appStore.generateDataLayer({ eventAction: 'step_5', eventLabel: 'algunos_productos_contratar_continuar' });
    }
    appStore.solicitarNuevaPortalidadStore.productosContratar = {
      creditoSeleccionado: this.state.creditoSeleccionado ? this.state.creditoSeleccionado : false,
      tarjetaSeleccionada: this.state.tarjetaSeleccionada ? this.state.tarjetaSeleccionada : false,
      cuentaVistaSeleccionada: this.state.cuentaVistaSeleccionada ? this.state.cuentaVistaSeleccionada : false,
      montoCredito: this.state.montoCredito,
      plazo: this.state.plazo,
      objetivoDeuda: this.state.objetivoDeuda,
    };
    appStore.changeNavigation(ViewConstants.ETAPA_RESUMEN_Y_FIRMA);
  };

  onVolver = () => {
    if (appStore.solicitarNuevaPortalidadStore.portaTodosSusProductos()) {
      appStore.changeNavigation(ViewConstants.ETAPA_SELECCION_BANCO);
    } else {
      appStore.changeNavigation(ViewConstants.ETAPA_NUEVA_PORTABILIDAD);
    }
  };

  renderDetalleCredito = (seleccionado) => {
    let result;
    const classSi = this.state.objetivoDeuda === SI ? 'bordeDestacado' : 'none';
    const classNo = this.state.objetivoDeuda === NO ? 'bordeDestacado' : 'none';
    let detalleCredito;
    if (this.state.objetivoDeuda === SI) {
      detalleCredito = (
        <div className="TextRipleyMontos">
          <div className="montoRipley">
            <TextRipleyComponent
              fullWidth={true}
              label="monto"
              value={ValidationUtils.formatMonto(this.state.montoCredito)}
              onChange={this.onChangeMonto}
              error={this.state.errorMonto}
              errorText={this.state.errorTxtMonto}
            />
            <div className="pesoMontoProducto">$</div>
          </div>
          <TextRipleyComponent fullWidth={true} label="plazo" value={this.state.plazo} error={this.state.errorPlazo} errorText={this.state.errorTxtPlazo} onChange={this.onChangePlazo} />
        </div>
      );
    }
    if (seleccionado) {
      result = (
        <div>
          <div className="motivo">
            <Typography className="tituloStepSolicitud">¿Tiene por objeto el pago de una o mas deudas vigentes determinadas?</Typography>
            <RadioGroup aria-label="gender" name="gender1" className="opcionesCompromiso Grande" onChange={this.onChangeObjetivoDeuda} value={this.state.objetivoDeuda}>
              <FormControlLabel control={<Radio color="primary" />} label="si" value={SI} className={classSi} />
              <FormControlLabel control={<Radio color="primary" />} label="no" value={NO} className={classNo} />
            </RadioGroup>
          </div>
          {detalleCredito}
        </div>
      );
    }
    return result;
  };

  render() {
    return (
      <div className="contenedorPrincipal">
        <div className="paso">
          <div>
            <Typography className="tituloBR">
              <IconButton onClick={this.onVolver}>
                <KeyboardBackspaceOutlined />
              </IconButton>
              Selección Productos a contratar
            </Typography>
          </div>
        </div>
        <LinearProgress variant="determinate" color="secondary" className="barraProgreso" value={appStore.navigationSection * (100 / ViewConstants.TOTAL_ETAPAS)} />
        <Typography className="tituloStepSolicitud">¿Qué productos desea contratar con Banco Ripley?</Typography>
        <div className="contenedorSwitch altoContenedorSwitch">
          <SwitchComponent etiqueta="Crédito de consumo" checked={this.state.creditoSeleccionado} onChange={this.onCreditoChange}></SwitchComponent>
          {this.renderDetalleCredito(this.state.creditoSeleccionado)}
        </div>
        <div className="contenedorSwitch altoContenedorSwitch">
          <SwitchComponent etiqueta="Cuenta vista" checked={this.state.cuentaVistaSeleccionada} onChange={this.onCuentaVistaChange}></SwitchComponent>
        </div>
        <div className="contenedorSwitch altoContenedorSwitch">
          <SwitchComponent etiqueta="Tarjeta de crédito" checked={this.state.tarjetaSeleccionada} onChange={this.onTarjetachange}></SwitchComponent>
        </div>
        <div className="botones">
          <Button color="primary" id="btnVerifica" className="btnRipley" fullWidth={true} onClick={this.onContinuar} disabled={!this.state.isValid}>
            Continuar
          </Button>
        </div>
      </div>
    );
  }
}
